<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh"><a href="#/SomeGirlsDo_toc#ackn-1"><em>Acknowledgements</em></a></p><p class="p1">I have been blessed with assistance and encouragement during the writing of this book and would like to thank the following people: Karen Solem and Karen Kosztolnyik, my two champions, thank you for helping to make this happen. Thank you to romantic suspense author Karen Rose for technical assistance, Binne Syril Braunstein, and longtime friends and colleagues Millie Criswell and Donna Kauffman for creative assistance. For professional and personal encouragement, heartfelt thanks to Cindy Gerard, Pamela Britton, Janet Evanovich, Joan Johnston, the Silhouette Desire loop. For real-world perspective, I don't know what I would do without the ladies-night-out group, my phantom general consultant, and my parents and family. To all of you, I'm humbled by your generosity and belief in me.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SomeGirlsDo_ackn-1.vue?1b41daba